import React from 'react';
import { motion } from 'framer-motion';
import { useGentleMotion as useReducedMotion } from '../hooks/useGentleMotion';
import { CheckIcon, StampIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { Doodles, DoodleSpec } from './Doodles';
import { ConfettiRain } from './ConfettiRain';
import { PASSPORT_VALUE_USD } from '../data/bonuses';
import { useMarket } from '../contexts/MarketContext';
import { estimatedInMarket } from '../utils/money';
const sparks: DoodleSpec[] = [{
  kind: 'sparkle',
  top: '12%',
  left: '8%',
  size: 18,
  color: '#F3A340'
}, {
  kind: 'star',
  top: '22%',
  left: '92%',
  size: 20,
  color: '#F6C453',
  rotate: 10
}, {
  kind: 'sparkle',
  top: '72%',
  left: '5%',
  size: 14,
  color: '#F27C70'
}, {
  kind: 'star',
  top: '82%',
  left: '88%',
  size: 16,
  color: '#2D8C5A',
  rotate: -12
}, {
  kind: 'dot',
  top: '46%',
  left: '52%',
  size: 8,
  color: '#6CBBD5'
}];
const features = ['Pasaporte imprimible', 'Stickers', 'Espacios para registrar retos', 'Niveles'];
export function Passport() {
  const reduce = useReducedMotion();
  const {
    market
  } = useMarket();
  return <section className="relative w-full overflow-hidden bg-cream2 py-11 sm:py-14" aria-labelledby="passport-title" data-id="element-201" data-mp="2h2mpxf63umdh">
      <ConfettiRain count={12} opacity={0.55} data-id="element-202" data-mp="2lums7e9ndrd8" />
      <Doodles specs={sparks} data-id="element-203" data-mp="2qsy4rwrbufz5" />

      <div className="relative mx-auto grid max-w-content grid-cols-1 items-center gap-10 px-5 sm:px-8 lg:grid-cols-2" data-id="element-204" data-mp="2qrwh8st4k10j">
        <Reveal data-id="element-205" data-mp="1t7a8dbuvfxnm">
          <span className="inline-flex rounded-full bg-sun/40 px-4 py-1.5 font-display text-[11px] font-extrabold uppercase tracking-[0.16em] text-navy" data-id="element-206" data-mp="1t7tqaskium1n">
            🎁 Regalo sorpresa
          </span>
          <h2 id="passport-title" className="mt-5 font-display text-2xl font-extrabold uppercase leading-tight text-navy sm:text-4xl" data-id="element-207" data-mp="235zpv3iuvg3c">
            Pasaporte de retos creativos
          </h2>
          <p className="mt-4 max-w-lg font-sans text-base leading-relaxed text-muted" data-id="element-208" data-mp="3jhdhgcmzkm7b">
            Cada actividad terminada se convierte en un nuevo logro.
          </p>

          <ul className="mt-6 grid grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-209" data-mp="1jhgo8yu2onzu">
            {features.map(f => <li key={f} className="flex items-center gap-2 font-sans text-sm text-ink" data-id="element-210" data-mp="1sgbrq35qfjzg">
                <CheckIcon className="h-4 w-4 shrink-0 text-brandgreen" aria-hidden="true" data-id="element-211" data-mp="1sdzchxrcznq3" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 inline-flex flex-wrap items-center gap-3 rounded-2xl bg-white px-5 py-3 shadow-soft" data-id="element-212" data-mp="10pxlmt3ynbyc">
            <span className="font-sans text-[11px] uppercase tracking-wide text-muted" data-id="element-213" data-mp="vrw0m2mz52k8">
              Valor estimado
            </span>
            <span className="font-display text-sm font-extrabold text-offer line-through" data-id="element-214" data-mp="14qzn7glco03h">
              {estimatedInMarket(PASSPORT_VALUE_USD, market)}
            </span>
            <span className="rounded-full bg-mint px-2.5 py-1 font-display text-[10px] font-extrabold uppercase tracking-wide text-brandgreen" data-id="element-215" data-mp="gz28nhqimtyo">
              Gratis con tu compra
            </span>
          </div>
        </Reveal>

        {/* Small passport-style emblem instead of a large mockup */}
        <motion.div className="flex justify-center" animate={reduce ? undefined : {
        y: [0, -8, 0],
        rotate: [-2, 2, -2]
      }} transition={{
        duration: 7,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-216" data-mp="7og00cp3rqpj">
          <div className="flex h-32 w-32 flex-col items-center justify-center rounded-3xl border-2 border-navy/15 bg-white shadow-soft sm:h-40 sm:w-40" data-id="element-217" data-mp="lme1wim8luo5">
            <StampIcon className="h-9 w-9 text-tangerine sm:h-11 sm:w-11" aria-hidden="true" data-id="element-218" data-mp="qkfupv9gt8ct" />
            <span className="mt-2 px-3 text-center font-display text-[9px] font-extrabold uppercase leading-tight tracking-[0.14em] text-navy sm:text-[10px]" data-id="element-219" data-mp="gn1cpr7w8bie">
              Pasaporte creativo
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}